import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { TRIAL_LIMIT } from '@/lib/planLimits'
import { Loader2 } from 'lucide-react'

export function ProtectedRoute() {
  const { user, loading, loja, trialAvaliacoesUsadas } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (loja) {
    if (loja.cortesia) return <Outlet />

    const subscriptionStatus = loja.stripe_subscription_status ?? 'trial'
    const hasActiveSubscription =
      Boolean(loja.stripe_subscription_id) &&
      ['active', 'trialing', 'canceling'].includes(subscriptionStatus)
    const trialExhausted = trialAvaliacoesUsadas >= TRIAL_LIMIT
    const hasStandaloneTrial = !hasActiveSubscription && !trialExhausted
    const accessDenied = !hasActiveSubscription && !hasStandaloneTrial
    if (accessDenied) return <Navigate to="/planos" replace />
  }

  return <Outlet />
}
